import { Box, Typography } from '@mui/material'

import Breadcrumbs, { BreadCrumb } from '@ecm/ui/element/Breadcrumbs'
import Color from '@ecm/ui/element/Color'
import MainContainer from '@ecm/ui/element/MainContainer'

type PlainHeaderProps = {
  breadCrumbList?: BreadCrumb[]
  children?: React.ReactNode
  title?: string
}

const PlainHeader = ({ breadCrumbList, children, title }: PlainHeaderProps) => (
  <Box
    py="4em"
    minHeight="20em"
    bgcolor={Color.smoke.normal}
    boxSizing="border-box"
    textAlign="center"
  >
    <MainContainer>
      {breadCrumbList && <Breadcrumbs breadCrumbList={breadCrumbList} />}
      {title && (
        <Typography variant="h2" component="h1" color={Color.mono.normal}>
          {title}
        </Typography>
      )}
      <Box display="inline-block">{children}</Box>
    </MainContainer>
  </Box>
)

export default PlainHeader
